// api
import { systemApi } from '../apis/system.api';

// action
import { actions } from '../actions/system.actionV2';

// models
import type { ResultError } from 'modules/common';
import type { ReqSubSystems, ResSystemSubListThunk } from '../models/system.model';

// libraries
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getSystemSubListV2 = createAsyncThunk<
  ResSystemSubListThunk,
  ReqSubSystems,
  {
    rejectValue: ResultError;
  }
>(actions.GET_SYSTEM_SUB_LIST, async (data, { fulfillWithValue, rejectWithValue }) => {
  try {
    const res = await systemApi.getSubSystems(data);

    const result = res.resultList.map((item) => ({
      label: item.cdNm,
      value: item.systemId
    }));

    return fulfillWithValue({ ...res, subListOptions: [...result] });
  } catch (error) {
    const err = error as ResultError;

    return rejectWithValue(err);
  }
});

/** 공종 조회 */
export const getDisciplineListV2 = createAsyncThunk<
  ResSystemSubListThunk,
  void,
  {
    rejectValue: ResultError;
  }
>(actions.GET_DISCIPLINE_LIST, async (_: void, { fulfillWithValue, rejectWithValue }) => {
  try {
    const res = await systemApi.getDisciplines();

    const result = res.resultList.map((item) => ({
      label: item.cdNm,
      value: item.systemId
    }));

    return fulfillWithValue({
      ...res,
      subListOptions: result
    });
  } catch (error) {
    const err = error as ResultError;

    return rejectWithValue(err);
  }
});
